import { importProvidersFrom, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { FuseModule } from '@fuse';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { FuseConfigModule } from '@fuse/services/config';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { appConfig } from 'app/core/config/app.config';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { mockApiServices } from 'app/mock-api';
import { environment } from 'environments/environment';
import { DayjsDateAdapter } from 'app/shared/dayjs-date-adapter';
import { MAT_DAYJS_DATE_FORMATS } from 'app/shared/dayjs-date-formats';
// Register Angular locale data for es-MX (needed for DatePipe)
import { registerLocaleData } from '@angular/common';
import localeEsMX from '@angular/common/locales/es-MX';
registerLocaleData(localeEsMX, 'es-MX');

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        { provide: DateAdapter, useClass: DayjsDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MAT_DAYJS_DATE_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
        { provide: LOCALE_ID, useValue: 'es-MX' },
        importProvidersFrom(
            BrowserModule,
            BrowserAnimationsModule,
            RouterModule.forRoot(appRoutes, routerConfig),
            // Fuse, FuseConfig & FuseMockAPI
            FuseModule,
            FuseConfigModule.forRoot(appConfig),
            ...(environment.useMockApi ? [FuseMockApiModule.forRoot(mockApiServices)] : []),

            // Core module of your application
            CoreModule,

            // Layout module of your application
            LayoutModule,
        ),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        provideAnimations(),
    ]
}).catch(err => console.error(err));
